/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Ops_Title3Inputs */

const en_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failure-proofing`)
};

const ar_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحصين ضد الفشل`)
};

const bn_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফেইলিওর-প্রুফিং`)
};

const de_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlersicherheit`)
};

const es_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A prueba de fallos`)
};

const fr_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protection contre les pannes`)
};

const pt_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À prova de falhas`)
};

const zh_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防故障`)
};

const tr_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arıza önleme`)
};

const ru_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Защита от сбоев`)
};

const pl_svc_automation_ops_title3 = /** @type {(inputs: Svc_Automation_Ops_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zabezpieczenie przed awariami`)
};

/**
* | output |
* | --- |
* | "Failure-proofing" |
*
* @param {Svc_Automation_Ops_Title3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_ops_title3 = /** @type {((inputs?: Svc_Automation_Ops_Title3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Ops_Title3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_ops_title3(inputs)
	if (locale === "bn") return bn_svc_automation_ops_title3(inputs)
	if (locale === "de") return de_svc_automation_ops_title3(inputs)
	if (locale === "es") return es_svc_automation_ops_title3(inputs)
	if (locale === "fr") return fr_svc_automation_ops_title3(inputs)
	if (locale === "pt") return pt_svc_automation_ops_title3(inputs)
	if (locale === "zh") return zh_svc_automation_ops_title3(inputs)
	if (locale === "tr") return tr_svc_automation_ops_title3(inputs)
	if (locale === "ru") return ru_svc_automation_ops_title3(inputs)
	if (locale === "pl") return pl_svc_automation_ops_title3(inputs)
	return en_svc_automation_ops_title3(inputs)
});
export { svc_automation_ops_title3 as "svc_automation_OPS_title" }